import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../Common/Header/Header';
import { useHistory } from 'react-router-dom';
import Button from '../../Common/Button/Button';
import FixedButton from '../../Common/FixedButton/FixedButton';
import CreditCardSeeList from '../../CreditCard/CreditCardSeeList';
const SeeCards = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [currentCardId, setCurrentCardId] = useState(null);
  const handleCardIdChange = (id) => {
    setCurrentCardId(id);
  };

  return (
    <>
      <Header showBack={true} title={t('yurCards')}></Header>
      <div style={{ marginBottom: '100px' }}>
        <CreditCardSeeList onCardIdChange={handleCardIdChange} />
      </div>

      <div
        style={{
          position: 'fixed',
          zIndex: 10000,
        }}
      >
        <FixedButton backgroundColor={'#000'}>
          <Button
            text={<div>{t('addCard')}</div>}
            size='large'
            icon
            color='#000'
            className='btn-primary'
            iconColor='#000'
            onClick={() => history.push('/create-card')}
          />
        </FixedButton>
      </div>
    </>
  );
};

export default SeeCards;
